import { gettext } from '@eventbrite/i18n';
import { MagnifyingGlassIcon, Typography } from '@eventbrite/marmalade';
import { logEvent } from '@eventbrite/statsig';
import loadable from '@loadable/component';
import React, { useState } from 'react';
import { HEAP_SEARCH_BOX_IN_HEADER_CLICK } from '../../constants/analytics';
import './SearchBar.scss';

const LazySearchTakeover = loadable.lib(
    () => import('@eventbrite/search-takeover'),
);

const SearchBar = () => {
    const [showSearch, setShowSearch] = useState(false);

    const handleClick = () => {
        logEvent(HEAP_SEARCH_BOX_IN_HEADER_CLICK);
        setShowSearch(true);
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            setShowSearch(true);
        }
    };

    function handleClose() {
        setShowSearch(false);
    }

    return (
        <>
            <button
                className="search-main"
                data-testid="header-search"
                onClick={handleClick}
                onKeyDown={handleKeyDown}
                aria-label={gettext('open search bar').toString()}
            >
                <Typography
                    variant="body-md"
                    as="span"
                    color="neutral-700"
                    className="search-content"
                >
                    <MagnifyingGlassIcon size="small" />
                    <span className="search-label">
                        {gettext('Let’s find something to do')}
                    </span>
                </Typography>
            </button>

            {showSearch ? (
                <LazySearchTakeover data-testid="search-takeover">
                    {({ SearchTakeover }: { SearchTakeover: any }) => (
                        <SearchTakeover
                            domNodeId="root"
                            onClose={handleClose}
                            isVisible={showSearch}
                            id="search-takeover"
                        />
                    )}
                </LazySearchTakeover>
            ) : null}
        </>
    );
};

export default SearchBar;
